var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    title: "Status change icon",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5V13H13.3444C12.9252 13.4729 12.4102 13.8513 11.8336 14.1099C11.257 14.3685 10.632 14.5015 10 14.5C8.80694 14.4987 7.6631 14.0242 6.81948 13.1805C5.97585 12.3369 5.50132 11.1931 5.50001 10H4.00001C3.99759 11.22 4.36788 12.4117 5.06133 13.4154C5.75478 14.4192 6.73829 15.1873 7.88022 15.6167C9.02215 16.0462 10.268 16.1166 11.4511 15.8185C12.6341 15.5204 13.6979 14.8681 14.5 13.9488V16H16V11.5H11.5Z",
    fill: "#0A5A67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C9.14755 4.00439 8.30572 4.18947 7.53005 4.54304C6.75437 4.89661 6.06247 5.41062 5.5 6.05117V4H4V8.5H8.5V7H6.6556C7.07478 6.52707 7.58977 6.14873 8.16639 5.89011C8.743 5.6315 9.36804 5.49851 10 5.5C11.1931 5.50131 12.3369 5.97584 13.1805 6.81947C14.0242 7.6631 14.4987 8.80693 14.5 10H16C15.9982 8.40926 15.3654 6.8842 14.2406 5.75938C13.1158 4.63455 11.5907 4.00183 10 4Z",
    fill: "#0A5A67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusChange);
export default __webpack_public_path__ + "static/media/status-change.4e57fd1b.svg";
export { ForwardRef as ReactComponent };